import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="page-shell footer-inner">
        <div className="footer-brand">
          <Link className="wordmark footer-wordmark" to="/">
            <span className="wordmark-mark" aria-hidden="true">n</span>
            <span>nori</span>
          </Link>
          <p>The operating system for business-owned communities.</p>
        </div>
        <div className="footer-links">
          <a href="/#workflow">Platform</a>
          <a href="/#segments">Who it is for</a>
          <a href="/#pricing">Pricing</a>
          <Link to="/case-studies">Case studies</Link>
          <Link to="/docs">Docs</Link>
          <Link to="/about">About Nori</Link>
          <Link to="/team">Team</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="footer-bottom"><span>© {new Date().getFullYear()} Nori</span><span>Built for the relationships that happen after the first visit.</span></div>
      </div>
    </footer>
  );
}
